import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState = { value:null};

const pdfSlice = createSlice({
  name: "pdf",
  initialState,
  reducers: {
    pdfSet: (state, action) => {
      //console.log("pdfSet",action.payload);
      state.value = action.payload;
    },
    pdfClear: (state) => {
      state.value = null;
    },
  },
});
export const { pdfSet, pdfClear } = pdfSlice.actions;
export default pdfSlice.reducer;
/*
 ( <Document>
  <Page size="A4" >
    <View >
      <Text >Abschnitt 1</Text>
    </View>
    <View >
      <Text >Abschnitt 2</Text>
    </View>
  </Page>
</Document>)
*/